import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faScrewdriver } from '@fortawesome/free-solid-svg-icons';
import { LinearProgress } from '@mui/material';
import { withRouter } from 'react-router-dom';
import {
    createDataSource, createGridOptions, DataGrid, indexCellRenderer, LinkCellRenderer, TextFilterDefaults,
} from '../common/dataGrid/DataGrid';
import DataGridSelectFilter from '../common/dataGrid/DataGridSelectFilter';
import CommonContext, { ApiRoutes } from '../Common';
import { PageHeading, PageWrap } from '../common/forms/FormElements';
import { CostCodeForm } from './CostCodeForm';
import DataGridSelectFloatingFilter from '../common/dataGrid/DataGridSelectFloatingFilter';
import DataGridToolbar from '../common/dataGrid/DataGridToolbar';

class CostCodeIndex extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);

        this.costCodeForm = React.createRef();

        this.state = {
            loading: true,
            roles: [],
            showCostCodeForm: false,
        };

        this.onAddCostCode = this.onAddCostCode.bind(this);
        this.onEditCostCode = this.onEditCostCode.bind(this);
        this.onCostCodeFormClosed = this.onCostCodeFormClosed.bind(this);
    }

    componentDidMount() { return this.populateState(); }

    onAddCostCode = () => {
        this.costCodeForm.current.open();
    };

    onEditCostCode = (id) => {
        this.costCodeForm.current.open(id);
    };

    onCostCodeFormClosed() {
        this.setState({ showCostCodeForm: false });
    }

    onCostCodeSaveCallback = (response) => {
        this.setState({ showCostCodeForm: false });
        this.context.setFormOpened(false);
        // Refresh grid
        this.state.gridApi.setDatasource(this.state.dataSource);
    };

    async populateState() {

        // Get grid defaults and handlers
        const gridOptions = createGridOptions(this);

        // Specify any custom components, filtering
        gridOptions.components = {
            selectFilter: DataGridSelectFilter,
            selectFloatingFilter: DataGridSelectFloatingFilter,
            nameRenderer: LinkCellRenderer,
        };

        // Provide column definitions
        gridOptions.columnDefs = [
            {
                flex: 0,
                width: 75,
                headerName: '',
                valueGetter: 'node.id',
                sortable: false,
                cellRenderer: indexCellRenderer,
            },
            {
                colId: 'Number',
                sortable: true,
                headerName: 'Number',
                field: 'costCodeNumber',
                sort: { direction: 'asc', priority: 0 },
                filter: 'agTextColumnFilter',
                floatingFilter: true,
                filterParams: TextFilterDefaults,
                floatingFilterComponentParams: {
                    suppressFilterButton: true,
                },
                cellRenderer: 'nameRenderer',
                cellRendererParams: {
                    clicked: this.onEditCostCode,
                    nameField: 'costCodeNumber',
                    idField: 'id',
                    title: 'View this Cost Code',
                },
            },
            {
                colId: 'Description',
                sortable: true,
                headerName: 'Description',
                field: 'description',
                sort: { direction: 'asc', priority: 0 },
                filter: 'agTextColumnFilter',
                floatingFilter: true,
                filterParams: TextFilterDefaults,
                floatingFilterComponentParams: {
                    suppressFilterButton: true,
                }
            }
        ];

        // Create datasource.  Is reused and rebound on refresh from the state.
        const dataSource = createDataSource(ApiRoutes.costCode.search(), gridOptions);

        this.setState((state) => ({
            loading: false,
            gridOptions,
            dataSource,
        }));
    }

    render() {
        if (this.state.loading) return (<LinearProgress variant="indeterminate" color="secondary" />);

        const { rowData, gridOptions } = this.state;

        return (
            <PageWrap>
                <PageHeading>
                    <FontAwesomeIcon icon={faScrewdriver} className="mr-2 text-muted" />
                    <span>CostCodes</span>
                </PageHeading>
                <DataGridToolbar
                    entity="equipmenttype"
                    gridApi={this.state.gridApi}
                    dataSource={this.state.dataSource}
                    onAdd={this.onAddCostCode}
                    addLabel="Add Cost Code"
                />
                <DataGrid
                    domLayout="normal"
                    rowData={rowData}
                    gridOptions={gridOptions}
                    gridStatus={this.state.gridStatus}
                />
                <CostCodeForm
                    ref={this.costCodeForm}
                    equipmentType={this.state.selectedCostCode}
                    onClose={this.onCostCodeFormClosed}
                    show={this.state.showCostCodeForm}
                    onSaveCallback={this.onCostCodeSaveCallback}
                />
            </PageWrap>
        );
    }
}
export default withRouter(CostCodeIndex);
